const styles = theme => ({
  dialogPaper: {
    minWidth: "700px",
    [theme.breakpoints.down("sm")]: {
      minWidth: "auto",
    },
  },
  dialogTitle: {
    // padding: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.primary.dark,
    color: "white",
  },
  dialogTitleText: {
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      fontSize: "1rem",
    },
  },
  closeIcon: {
    color: "white",
  },
  leftContainer: {
    backgroundColor: "rgba(232, 232, 232, 0.5)",
  },
  HeadContainer: {
    margin: "20px",
  },
  autoComplete: {
    zIndex: 100,
  },

  leftSpacing: {
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(5),
    marginTop: theme.spacing(5),
  },
  rigthSpacing: {
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(5),
    marginTop: theme.spacing(5),
  },
  dialogContent: {
    padding: 0,
    margin: 0,
  },
  gridContainer: {
    // padding: theme.spacing(2),
  },
  input: {
    marginBottom: theme.spacing(3),
  },
  dialogActions: {
    position: "absolute",
    bottom: 20,
    right: 20,
  },
  headlineWrapper: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
    minHeght: 32,
  },
  margin: {
    margin: theme.spacing(2),
  },
  padding: {
    padding: theme.spacing(1),
  },
  alignClass: {
    textAlign: "left",
    marginTop: "20px",
  },
  backgroundGreen: {
    backgroundColor: "#c1e9d7",
    padding: "0px 10px",
  },
  noteLineText: {
    fontSize: "0.75rem",
    fontWeight: 600,
  },
  shootDescription: {
    textAlign: "left",
    whiteSpace: "pre-line",
  },
  noteLineTextCrew: {
    color: "black",
    fontSize: "0.7rem",
    fontWeight: 500,
  },
  noteLineRoleTextCrew: {
    color: "black",
    fontSize: "0.65rem",
    fontWeight: 600,
  },
  headline: {
    opacity: 0.6,
    display: "inline",
    color: "#000000de",
    fontSize: "0.85rem",
  },
  backgroundLight: {
    backgroundColor: "#f6f6fe",
    height: "fit-content",
    padding: "0",
    paddingTop: "5px",
    borderRadius: "5px",
  },
  positionAbsolute: {
    position: "absolute",
    width: "35px",
    height: "35px",
  },
  fullWidth: {
    width: "100%",
  },
  alignLeft: {
    textAlign: "left",
    fontSize: "0.85rem",
  },
  detailsHeading: {
    textAlign: "left",
    fontSize: "0.75rem",
    fontWeight: 600,
  },
  marginLeft: {
    marginLeft: theme.spacing(5),
  },
  editIcon: {
    cursor: "pointer",
    marginBottom: "10px",
    marginRight: "20px",
    width: "30px",
    height: "30px",
    [theme.breakpoints.down("sm")]: {
      margin: "10px",
      width: "20px",
      height: "20px",
    },
  },
  duplicateIcon: {
    cursor: "pointer",
    marginBottom: "10px",
    width: "30px",
    height: "30px",
    [theme.breakpoints.down("sm")]: {
      margin: "10px",
      width: "20px",
      height: "20px",
    },
  },
  statusWrap: {
    padding: "16px",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  textBold: {
    fontWeight: 600,
  },
  positionSlide: {
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "100%",
    height: "fit-content",
    backgroundColor: "#fbe6aa",
  },
  duplicateShootTitle: {
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      fontSize: "1rem",
    },
    margin: "8px",
  },
  picker: {
    transform: "scale(0.8)",
    display: "flex",
  },
  selectedDay: {
    fontWeight: "400",
  },
  unselectedDay: {
    color: "grey",
  },
  paddingLeft: {
    paddingLeft: theme.spacing(1),
  },
})

export default styles
